var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$badges.length)?_c('ymap-marker',{attrs:{"marker-id":_vm.id,"coords":_vm.coords,"icon":_vm.markerSymbol()}},[_c('PopUp',{attrs:{"slot":"balloon","id":_vm.id,"title":_vm.title,"image":_vm.image,"service":"content/event","address":_vm.address},slot:"balloon"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }